import axiosInstance from "../Services/Api/axiosInstance";

export const checkComplaints = async () => {
  try {
    const res = await axiosInstance.get('/complaints');
    return res.data?.hasComplaints;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error fetching complaints table");
  }
}
